import React from 'react';

class DateCellEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.formatDateToISO(props.value) || '',
            originalFormat: this.detectDateFormat(props.value)
        };
    }

    detectDateFormat = (val) => {
        return 'MM/DD/YYYY';
    }

    formatDateToISO = (val) => {
        if (!val) return '';
        if (typeof val === 'string') {
            const date = this.parseDate(val);
            if (date && !isNaN(date.getTime())) {
                return date.toISOString().split('T')[0];
            }
            return val;
        }
        try {
            const date = new Date(val);
            if (isNaN(date.getTime())) return '';
            return date.toISOString().split('T')[0];
        } catch (e) {
            return '';
        }
    }

    parseDate = (dateStr) => {
        if (!dateStr) return null;
        let parts;
        if (dateStr.includes('/')) {
            parts = dateStr.split('/');
        } else if (dateStr.includes('-')) {
            parts = dateStr.split('-');
        }

        if (parts && parts.length === 3) {
            const first = parseInt(parts[0], 10);
            const second = parseInt(parts[1], 10);
            const third = parseInt(parts[2], 10);

            // Support both MM/DD/YYYY and YYYY/MM/DD inputs.
            if (parts[0].length === 4) {
                return new Date(first, second - 1, third);
            }
            return new Date(third, first - 1, second);
        }
        return new Date(dateStr);
    }

    formatDateToOriginal = (isoDate, originalFormat) => {
        if (!isoDate) return '';
        const parts = isoDate.split('-');
        if (parts.length !== 3) return isoDate;
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
        return `${month}/${day}/${year}`;
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.eInput) {
                this.eInput.addEventListener('input', this.handleDateChange);
                this.eInput.focus();
                this.eInput.click();
            }
        }, 0);
    }

    componentWillUnmount() {
        if (this.eInput) {
            this.eInput.removeEventListener('input', this.handleDateChange);
        }
    }

    getValue() {
        return this.formatDateToOriginal(this.state.value, this.state.originalFormat);
    }

    stopEditing(suppress) {
        if (suppress) {
            this.setState({value: this.formatDateToISO(this.props.value)});
        }
    }

    isCancelAfterEnd() {
        return false;
    }

    handleDateChange = (event) => {
        const selectedDate = event.target.value;
        this.setState({value: selectedDate});
    }

    handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === 'Escape' || event.key === 'Tab') {
            return;
        }
    }

    render() {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const minDate = yesterday.toISOString().split('T')[0];

        return (
            <input
                ref={(input) => this.eInput = input}
                type="date"
                value={this.state.value}
                onChange={this.handleDateChange}
                onKeyDown={this.handleKeyDown}
                min={minDate}
                style={{
                    width: '100%',
                    padding: '6px',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    boxSizing: 'border-box'
                }}
                autoFocus
            />
        );
    }
}

export default DateCellEditor;

